import API_URL from "./config";
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

import Login from "./components/Login";
import AdminPanel from "./components/AdminPanel";
import ProfesorPanel from "./components/ProfesorPanel";
import PadrePanel from "./components/PadrePanel";
import ServiciosCitas from "./components/ServiciosCitas";
import GradosCDA from "./components/GradosCDA";
import FooterLogin from "./components/FooterLogin";
import { armarFondo } from "./utils/fondoServicio";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { IdiomaProvider } from "./context/IdiomaContext";
import { EstiloProvider } from "./context/EstiloContext";




function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <IdiomaProvider>
          <EstiloProvider>
            <MainApp />
          </EstiloProvider>
        </IdiomaProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

const MainApp = () => {
  const { usuario, setUsuario } = useAuth();
  const [colorFondo, setColorFondo] = useState("#ffffff");
  const [coloresSitio, setColoresSitio] = useState({
    base: "#1e40af",
    header: "#1e40af",
    footer: "#1e40af",
    sidebar: "#1e40af",
  });
  const [tituloLogin, setTituloLogin] = useState("CDA Corte 3 2026");

  useEffect(() => {

    const cargarColor = async () => {

      try {

        // ⭐ primero revisa si hay fondo del servicio
        const fondoServicio = localStorage.getItem("fondoServicio");

        if (fondoServicio) {
          setColorFondo(fondoServicio);
          return;
        }

        // si no hay fondo del servicio usa el fondo global
        const res =await axios.get(
  `${API_URL}/api/color-fondo`
);

        setColorFondo(armarFondo(res.data.fondo_app, res.data.fondo_difuminado));

      } catch (error) {
        console.error("Error al obtener color de fondo:", error);
      }

    };

    cargarColor();

    const cargarColoresSitio = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/colores-sitio/efectivo`);
        setColoresSitio(res.data);
      } catch (error) {
        console.error("Error al obtener colores del sitio:", error);
      }
    };

    cargarColoresSitio();

    const cargarTituloLogin = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/configuracion-login`);
        setTituloLogin(res.data.titulo);
      } catch (error) {
        console.error("Error al obtener el título del login:", error);
      }
    };

    cargarTituloLogin();

  }, []);

  const handleLogout = () => {

    localStorage.removeItem("usuario");
    localStorage.removeItem("token");
    localStorage.removeItem("colorServicio");
    localStorage.removeItem("fondoServicio");

    setUsuario(null);
  };

  if (!usuario) {
    return (
      <Login
        onLogin={setUsuario}
        colorFondo={colorFondo}
        titulo={tituloLogin}
      />
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: colorFondo,
        transition: "background 0.3s ease",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* CONTENIDO */}
      <div style={{ flex: 1 }}>
        <Routes>

          {usuario.role === "admin" && (
            <Route
              path="/*"
              element={
                <AdminPanel
                  usuario={usuario}
                  onLogout={handleLogout}
                  colorFondo={colorFondo}
                  setColorFondoGlobal={setColorFondo}
                  colorSidebar={coloresSitio.sidebar}
                />
              }
            />
          )}

          {usuario.role === "profesor" && (
            <Route
              path="/*"
              element={
                <ProfesorPanel
                  usuario={usuario}
                  onLogout={handleLogout}
                  colorFondo={colorFondo}
                />
              }
            />
          )}

          {usuario.role === "padre" && (
            <Route
              path="/*"
              element={
                <PadrePanel
                  usuario={usuario}
                  onLogout={handleLogout}
                  colorFondo={colorFondo}
                  colorHeader={coloresSitio.header}
                />
              }
            />
          )}

          <Route
            path="/grados-cda"
            element={<GradosCDA colorFondo={colorFondo} />}
          />

          <Route
            path="*"
            element={<ServiciosCitas colorFondo={colorFondo} />}
          />

        </Routes>
      </div>

      {/* FOOTER GLOBAL */}
<FooterLogin colorFondo={coloresSitio.footer} />




    </div>
  );
};

export default App;
